import { Navigate } from 'react-router-dom';
import type { FC } from 'react';

export const IndexPage: FC = () => {
  return <Navigate to="/courses" replace />;
};
